module.exports = __webpack_public_path__ + "static/media/pic6.9d1dde12.jpg";